/**
 * All Death Knight abilities except talents go in here. You can also put a talent in here if you want to override something imported in the `./talents` folder, but that should be extremely rare.
 * You need to do this manually, usually an easy way to do this is by opening a WCL report and clicking the icons of spells to open the relevant Wowhead pages, here you can get the icon name by clicking the icon, copy the name of the spell and the ID is in the URL.
 * You can access these entries like other entries in the spells files by importing `common/SPELLS` and using the assigned property on the SPELLS object. Please try to avoid abbreviating properties.
 */

import Spell, { Enchant } from './Spell';

const spells = {
  // region Hero Talents
  // Deathbringer:
  EXTERMINATE_BUFF: {
    id: 441416,
    name: 'Exterminate',
    icon: 'ability_argus_edgeofobliteration',
  },

  EXTERMINATE_PAINFUL_DEATH_BUFF: {
    id: 447954,
    name: 'Exterminate',
    icon: 'ability_argus_edgeofobliteration',
  },

  EXTERMINATE_FIRST_HIT: {
    id: 441424,
    name: 'Exterminate',
    icon: 'inv_polearm_2h_titanargus_d_01',
  },
  EXTERMINATE_SECOND_HIT: {
    id: 441426,
    name: 'Exterminate',
    icon: 'inv_polearm_2h_titanargus_d_01',
  },

  // region Blood Specialization
  DEATHS_CARESS: {
    id: 195292,
    name: "Death's Caress",
    icon: 'ability_deathknight_deathscaress.jpg',
  },

  //Summons
  //Bloodworm summon spell by the Bloodworms talent
  BLOODWORM: {
    id: 196361,
    name: 'Bloodworm',
    icon: 'spell_shadow_soulleech',
  },
  //Bloodworm death/heal spell
  BLOODWORM_DEATH: {
    id: 197509,
    name: 'Bloodworm Death/Heal',
    icon: 'spell_shadow_soulleech',
  },

  // Damage Dealing
  BONESTORM_TALENT_HIT: {
    id: 196528,
    name: 'Bonestorm',
    icon: 'achievement_boss_lordmarrowgar',
  },

  // Only used during Dancing Rune Weapon. Its the Heart Strike of the copied weapons. Generates 5 RP.
  BLOOD_STRIKE: {
    id: 220890,
    name: 'Blood Strike',
    icon: 'spell_deathknight_deathstrike',
  },
  BLOOD_PLAGUE: {
    id: 55078,
    name: 'Blood Plague',
    icon: 'spell_deathknight_bloodplague',
  },

  // Cooldowns
  DANCING_RUNE_WEAPON_TALENT_BUFF: {
    id: 81256,
    name: 'Dancing Rune Weapon',
    icon: 'inv_sword_07',
  },

  SHROUD_OF_PURGATORY: {
    id: 116888,
    name: 'Shroud of Purgatory',
    icon: 'inv_misc_shadowegg',
  },

  BONE_SHIELD: {
    id: 195181,
    name: 'Bone Shield',
    icon: 'ability_deathknight_boneshield',
  },

  BLOOD_SHIELD: {
    id: 77535,
    name: 'Blood Shield',
    icon: 'spell_deathknight_butcher2',
  },

  CONSUMPTION_TALENT_HEAL: {
    id: 205224,
    name: 'Consumption Heal',
    icon: 'inv_axe_2h_artifactmaw_d_02',
  },

  // Buffs
  OSSUARY_TALENT_BUFF: {
    id: 219788,
    name: 'Ossuary',
    icon: 'ability_deathknight_brittlebones',
  },
  CRIMSON_SCOURGE_TALENT_BUFF: {
    id: 81141,
    name: 'Crimson Scourge',
    icon: 'ability_warrior_bloodnova',
  },
  VORACIOUS_TALENT_BUFF: {
    id: 274009,
    name: 'Voracious',
    icon: 'ability_ironmaidens_whirlofblood',
  },
  RELISH_IN_BLOOD: {
    id: 317614,
    name: 'Relish in Blood',
    icon: 'ability_deathknight_roilingblood',
  },
  COAGULOPATHY_BUFF: {
    id: 391477,
    name: 'Coagulopathy',
    icon: 'ability_skeer_bloodletting',
  },

  // Other
  HEARTBREAKER_ENERGIZE: {
    id: 210738,
    name: 'Heartbreaker',
    icon: 'spell_deathknight_deathstrike',
  },
  UMBILICUS_ETERNUS_BUFF: {
    id: 391527,
    name: 'Umbilicus Eternus',
    icon: 'artifactability_blooddeathknight_umbilicuseternus',
  },

  // region Frost Specialization

  // Damage Dealing

  FROST_FEVER: {
    id: 55095,
    name: 'Frost Fever',
    icon: 'spell_deathknight_frostfever',
  },
  FROST_STRIKE_DAMAGE: {
    id: 325464,
    name: 'Frost Strike',
    icon: 'spell_deathknight_empowerruneblade2',
  },
  FROST_STRIKE_MAIN_HAND_DAMAGE: {
    id: 222026,
    name: 'Frost Strike',
    icon: 'spell_deathknight_empowerruneblade2',
  },
  FROST_STRIKE_OFF_HAND_DAMAGE: {
    id: 66196,
    name: 'Frost Strike',
    icon: 'spell_deathknight_empowerruneblade2',
  },
  OBLITERATE_DAMAGE: {
    id: 325461,
    name: 'Obliterate',
    icon: 'spell_deathknight_classicon',
  },
  OBLITERATE_MAIN_HAND_DAMAGE: {
    id: 222024,
    name: 'Obliterate',
    icon: 'spell_deathknight_classicon',
  },
  OBLITERATE_OFF_HAND_DAMAGE: {
    id: 66198,
    name: 'Obliterate',
    icon: 'spell_deathknight_classicon',
  },
  REMORSELESS_WINTER: {
    id: 196770,
    name: 'Remorseless Winter',
    icon: 'ability_deathknight_remorselesswinters2',
    runesCost: 1,
  },
  REMORSELESS_WINTER_ENV_CAST: {
    // not actually sure what this does
    id: 211793,
    name: 'Remorseless Winter',
    icon: 'ability_deathknight_remorselesswinters2',
  },
  REMORSELESS_WINTER_DAMAGE: {
    // every tick puts a cast event on the environment and also the id of the damage event
    id: 196771,
    name: 'Remorseless Winter',
    icon: 'ability_deathknight_remorselesswinters2',
  },
  GATHERING_STORM_TALENT_BUFF: {
    id: 211805,
    name: 'Gathering Storm',
    icon: 'spell_frost_iceshards',
  },
  BREATH_OF_SINDRAGOSA_TALENT_DAMAGE_TICK: {
    id: 155166,
    name: 'Breath of Sindragosa',
    icon: 'spell_deathknight_breathofsindragosa',
  },
  // Procs
  RIME: {
    id: 59052,
    name: 'Rime',
    icon: 'spell_frost_arcticwinds',
  },

  KILLING_MACHINE: {
    id: 51124,
    name: 'Killing Machine',
    icon: 'inv_sword_122',
  },

  RAZORICE: {
    id: 50401,
    name: 'Razorice',
    icon: 'spell_deathknight_frozenruneweapon',
  },

  RUNIC_EMPOWERMENT: {
    id: 193486,
    name: 'Runic Empowerment',
    icon: 'inv_misc_rune_10',
  },

  MURDEROUS_EFFICIENCY: {
    id: 207062,
    name: 'Murderous Efficiency',
    icon: 'spell_frost_frostarmor',
  },

  FROST_FEVER_RP_GAIN: {
    id: 195617,
    name: 'Frost Fever',
    icon: 'spell_deathknight_frostfever',
  },

  RUNIC_ATTENUATION_RP_GAIN: {
    id: 221322,
    name: 'Runic Attenuation',
    icon: 'boss_odunrunes_blue',
  },

  BREATH_OF_SINDRAGOSA_TALENT_RUNE_GAIN: {
    id: 303753,
    name: 'Breath of Sindragosa',
    icon: 'inv_misc_rune_10',
  },

  OBLITERATION_RUNE_GAIN: {
    id: 281327,
    name: 'Obliteration',
    icon: 'inv_axe_114',
  },
  GLACIAL_ADVANCE: {
    id: 194913,
    name: 'Glacial Advance',
    icon: 'ability_hunter_glacialtrap',
    runicPowerCost: 30,
  },

  // region Unholy Specialization
  FESTERING_SCYTHE: {
    id: 458128,
    name: 'Festering Scythe',
    icon: 'inv_polearm_2h_mawnecromancerboss_d_01_darkblue',
    runesCost: 2,
    runicPowerCost: -20,
  },

  // Buff on the player while Festering Scythe is active
  FESTERING_SCYTHE_BUFF: {
    id: 1241077,
    name: 'Festering Scythe',
    icon: 'inv_polearm_2h_mawnecromancerboss_d_01_darkblue',
  },

  DEATH_CHARGE: {
    id: 444347,
    name: 'Death Charge',
    icon: 'ability_mount_steelwarhorse',
  },

  MOGRAINES_MIGHT: {
    id: 444505,
    name: "Mograine's Might",
    icon: 'ability_warlock_improvedsoulleech',
  },

  GHOULISH_FRENZY: {
    id: 377588,
    name: 'Ghoulish Frenzy',
    icon: 'ability_warlock_baneofhavoc',
  },

  // Buff applied to pets during Dark Transformation when Commander of the Dead talent is active
  COMMANDER_OF_THE_DEAD_BUFF: {
    id: 390264,
    name: 'Commander of the Dead',
    icon: 'spell_shadow_fumble',
  },

  // Summon event for Lesser Ghouls from regular gameplay (Scourge Strike consuming Festering Strike buff)
  LESSER_GHOUL: {
    id: 275430,
    name: 'Lesser Ghoul',
    icon: 'inv_ghoulnorthrend',
  },

  // Summon event for the old Army of the Dead ghouls (pre-Midnight)
  ARMY_SUMMON: {
    id: 42651,
    name: 'Army of the Dead',
    icon: 'spell_shadow_coneofsilence',
  },

  OUTBREAK: {
    id: 77575,
    name: 'Outbreak',
    icon: 'spell_deathvortex',
    runesCost: 1,
    runicPowerCost: -10,
  },

  RUNIC_CORRUPTION: {
    id: 51460,
    name: 'Runic Corruption',
    icon: 'spell_shadow_rune',
  },

  // scourge strike has one cast event but two damage events, the cast and physical
  // damage happen on id 55090 (talent), the shadow damage is on id 70890
  SCOURGE_STRIKE_SHADOW_DAMAGE: {
    id: 70890,
    name: 'Scourge Strike',
    icon: 'spell_deathknight_scourgestrike',
  },

  VIRULENT_PLAGUE: {
    id: 191587,
    name: 'Virulent Plague',
    icon: 'ability_creature_disease_02',
  },

  EPIDEMIC: {
    id: 207317,
    name: 'Epidemic',
    icon: 'spell_nature_nullifydisease',
    runicPowerCost: 30,
  },

  EPIDEMIC_DAMAGE: {
    id: 212739,
    name: 'Epidemic',
    icon: 'spell_nature_nullifydisease',
  },

  SOUL_REAPER_TALENT_SECOND_HIT: {
    id: 343295,
    name: 'Soul Reaper',
    icon: 'ability_deathknight_soulreaper',
  },

  SOUL_REAPER_DEBUFF: {
    id: 1241521,
    name: 'Soul Reaper',
    icon: 'ability_deathknight_soulreaper',
  },

  SUDDEN_DOOM_BUFF: {
    id: 81340,
    name: 'Sudden Doom',
    icon: 'spell_shadow_painspike',
  },

  FESTERING_STRIKE: {
    id: 85948,
    name: 'Festering Strike',
    icon: 'spell_deathknight_festering_strike',
    runesCost: 2,
  },
  // Buff tracking Lesser Ghoul summon availability
  LESSER_GHOUL_BUFF: {
    id: 1254252,
    name: 'Lesser Ghoul',
    icon: 'spell_deathknight_festering_strike',
  },
  // Tracks active Lesser Ghoul count
  LESSER_GHOUL_ACTIVE: {
    id: 1242998,
    name: 'Lesser Ghoul',
    icon: 'inv_ghoulnorthrend',
  },

  DREAD_PLAGUE: {
    id: 1240996,
    name: 'Dread Plague',
    icon: 'inv12_ability_deathknight_empowereddreadplague',
  },

  // Buff applied to the main ghoul pet during Dark Transformation
  DARK_TRANSFORMATION_PET_BUFF: {
    id: 1233448,
    name: 'Dark Transformation',
    icon: 'achievement_boss_festergutrotface',
  },

  // Buff on the player while Dark Transformation is active
  DARK_TRANSFORMATION_BUFF: {
    id: 1235391,
    name: 'Dark Transformation',
    icon: 'achievement_boss_festergutrotface',
  },

  // Buff on the player while Army of the Dead is channeling
  ARMY_OF_THE_DEAD_BUFF: {
    id: 42650,
    name: 'Army of the Dead',
    icon: 'spell_deathknight_armyofthedead',
  },

  // Summon event for Lesser Ghouls from Apocalypse/Putrefy (empowered variant, NPC 258578)
  LESSER_GHOUL_SUMMON_EMPOWERED: {
    id: 1277098,
    name: 'Lesser Ghoul',
    icon: 'inv_ghoulnorthrend',
  },

  // Summon event for Lesser Ghouls spawned during Army of the Dead cast (NPC 237409)
  LESSER_GHOUL_SUMMON_ARMY: {
    id: 1282535,
    name: 'Lesser Ghoul',
    icon: 'inv_ghoulnorthrend',
  },

  // Summon event for main ghoul pet (Raise Dead)
  RAISE_DEAD_SUMMON: {
    id: 52150,
    name: 'Raise Dead',
    icon: 'spell_shadow_animatedead',
  },

  // Summon event for Ebon Gargoyle (fires when Summon Gargoyle talent is used)
  SUMMON_GARGOYLE: {
    id: 49206,
    name: 'Summon Gargoyle',
    icon: 'ability_deathknight_summongargoyle',
  },

  // Summon event for Abomination (fires when Raise Abomination talent is used)
  RAISE_ABOMINATION_SUMMON: {
    id: 288853,
    name: 'Raise Abomination',
    icon: 'achievement_boss_patchwerk',
  },

  // Summon event for Magus of the Dead from Apocalypse procs (later in combat)
  MAGUS_OF_THE_DEAD_SUMMON: {
    id: 1242294,
    name: 'Army of the Damned',
    icon: 'ability_maldraxxus_mage',
  },

  // Summon event for Magus of the Dead spawned during Army of the Dead cast
  MAGUS_OF_THE_DEAD_SUMMON_ARMY: {
    id: 317776,
    name: 'Army of the Damned',
    icon: 'artifactability_unholydeathknight_deathsembrace',
  },

  // Summon event for Highlord Darion Mograine (Rider of the Apocalypse horseman)
  SUMMON_MOGRAINE: {
    id: 444248,
    name: 'Summon Mograine',
    icon: 'inv_helmet_151',
  },

  // Summon event for High Inquisitor Whitemane (Rider of the Apocalypse horseman)
  SUMMON_WHITEMANE: {
    id: 444251,
    name: 'Summon Whitemane',
    icon: 'achievement_character_human_female',
  },

  // Summon event for Nazgrim (Rider of the Apocalypse horseman)
  SUMMON_NAZGRIM: {
    id: 444252,
    name: 'Summon Nazgrim',
    icon: 'achievement_boss_general_nazgrim',
  },

  // Summon event for King Thoras Trollbane (Rider of the Apocalypse horseman)
  SUMMON_TROLLBANE: {
    id: 444254,
    name: 'Summon Trollbane',
    icon: 'achievement_character_human_male',
  },

  // Buff granted by the Forbidden Knowledge apex talent after Army of the Dead
  FORBIDDEN_KNOWLEDGE_BUFF: {
    id: 1242223,
    name: 'Forbidden Knowledge',
    icon: 'inv12_apextalent_deathknight_forbiddenknowledge',
  },

  // Necrotic Coil - replaces Death Coil after Army of the Dead when Forbidden Knowledge talent is active
  NECROTIC_COIL: {
    id: 1242174,
    name: 'Necrotic Coil',
    icon: 'spell_animamaldraxxus_missile',
    runicPowerCost: 30,
  },
  // Primary Shadowstrike damage to up to 3 foes
  NECROTIC_COIL_DAMAGE_HIT: {
    id: 1242178,
    name: 'Necrotic Coil',
    icon: 'spell_animamaldraxxus_missile',
  },
  // Shadow damage to all pierced enemies
  NECROTIC_COIL_DAMAGE_PIERCE: {
    id: 1242172,
    name: 'Necrotic Coil',
    icon: 'spell_animamaldraxxus_missile',
  },

  // Graveyard - replaces Epidemic after Army of the Dead when Forbidden Knowledge talent is active
  GRAVEYARD: {
    id: 383269,
    name: 'Graveyard',
    icon: 'spell_necro_deathall',
    runicPowerCost: 30,
  },
  GRAVEYARD_DAMAGE: {
    id: 383313,
    name: 'Graveyard',
    icon: 'spell_necro_deathall',
  },

  // Unholy Aura haste buff - stacks per active Magus of the Dead
  UNHOLY_AURA_BUFF: {
    id: 1268917,
    name: 'Unholy Aura',
    icon: 'ability_deathknight_decomposingaura',
  },

  // Damage aura from Abomination pet
  DISEASE_CLOUD: {
    id: 1244102,
    name: 'Disease Cloud',
    icon: 'achievement_boss_patchwerk',
  },

  // region Death Knight General
  CHAINS_OF_ICE: {
    id: 45524,
    name: 'Chains of Ice',
    icon: 'spell_frost_chainsofice',
    runesCost: 1,
    runicPowerCost: -10,
  },
  RUNE_STRIKE: {
    id: 316239,
    name: 'Rune Strike',
    icon: 'spell_deathknight_darkconviction',
    runesCost: 1,
    runicPowerCost: -10,
  },
  RUNEFORGING: {
    id: 53428,
    name: 'Runeforging',
    icon: 'spell_deathknight_frozenruneweapon',
  },
  //Rune of the Fallen Crusader Proc
  UNHOLY_STRENGTH_BUFF: {
    id: 53365,
    name: 'Unholy Strength',
    icon: 'spell_holy_blessingofstrength',
  },

  //Rune of Unending Thirst Proc
  RUNE_OF_UNENDING_THIRST_BUFF: {
    id: 326984,
    name: 'Rune of Unending Thirst',
    icon: 'spell_nzinsanity_bloodthirst',
  },

  //Rune of Spellwarding
  RUNE_OF_SPELLWARDING_BUFF_SHIELD: {
    id: 326867,
    name: 'Rune of Spellwarding',
    icon: 'spell_fire_twilightfireward',
  },

  //Rune of Sanguination
  RUNE_OF_SANGUINATION_BUFF_HEAL: {
    id: 326808,
    name: 'Rune of Sanguination',
    icon: 'ability_argus_deathfog',
  },

  //Rune of Hysteria RP Buff
  RUNE_OF_HYSTERIA_BUFF: {
    id: 326918,
    name: 'Rune of Hysteria',
    icon: 'ability_deathknight_runicimpowerment',
  },

  ANTI_MAGIC_SHELL: {
    id: 48707,
    name: 'Anti-Magic Shell',
    icon: 'spell_shadow_antimagicshell.jpg',
  },
  ANTI_MAGIC_ZONE_TALENT_BUFF: {
    id: 145629,
    name: 'Anti-Magic Zone',
    icon: 'spell_deathknight_antimagiczone',
  },

  ANTI_MAGIC_SHELL_RP_GAINED: {
    id: 49088,
    name: 'Anti-Magic Shell',
    icon: 'spell_holy_righteousnessaura',
  },

  DARK_COMMAND: {
    id: 56222,
    name: 'Dark Command',
    icon: 'spell_nature_shamanrage',
  },

  DEATH_GRIP: {
    id: 49576,
    name: 'Death Grip',
    icon: 'spell_deathknight_strangulate',
  },

  DEATH_AND_DECAY: {
    id: 43265,
    name: 'Death and Decay',
    icon: 'spell_shadow_deathanddecay',
    runesCost: 1,
    runicPowerCost: -10,
  },

  DEATH_AND_DECAY_BUFF: {
    id: 188290,
    name: 'Death and Decay',
    icon: 'spell_shadow_deathanddecay',
  },

  DEATH_AND_DECAY_DAMAGE_TICK: {
    id: 52212,
    name: 'Death and Decay',
    icon: 'spell_shadow_deathanddecay',
  },

  DEATH_STRIKE_HEAL: {
    id: 45470,
    name: 'Death Strike',
    icon: 'spell_deathknight_butcher2',
  },

  DEATH_GATE: {
    id: 50977,
    name: 'Death Gate',
    icon: 'spell_arcane_teleportundercity',
    runesCost: 1,
    runicPowerCost: -10,
  },

  DEATHS_ADVANCE: {
    id: 48265,
    name: "Death's Advance",
    icon: 'spell_shadow_demonicempathy',
  },

  PATH_OF_FROST: {
    id: 3714,
    name: 'Path of Frost',
    icon: 'spell_deathknight_pathoffrost',
  },

  RAISE_ALLY: {
    id: 61999,
    name: 'Raise Ally',
    icon: 'spell_shadow_deadofnight',
    runicPowerCost: 30,
  },

  DEATH_COIL: {
    id: 47541,
    name: 'Death Coil',
    icon: 'spell_shadow_deathcoil',
    runicPowerCost: 30,
  },

  DEATH_COIL_DAMAGE: {
    id: 47632,
    name: 'Death Coil',
    icon: 'spell_shadow_deathcoil',
  },

  LICHBORNE: {
    id: 49039,
    name: 'Lichborne',
    icon: 'spell_shadow_raisedead',
  },

  RUNE_1: {
    id: -101,
    name: 'Rune 1',
    icon: 'spell_deathknight_frozenruneweapon',
  },
  RUNE_2: {
    id: -102,
    name: 'Rune 2',
    icon: 'spell_deathknight_frozenruneweapon',
  },
  RUNE_3: {
    id: -103,
    name: 'Rune 3',
    icon: 'spell_deathknight_frozenruneweapon',
  },

  RUNIC_POWER: {
    id: 189096,
    name: 'Runic Power',
    icon: 'inv_sword_62',
  },

  VAMPIRIC_STRIKE: {
    id: 433895,
    name: 'Vampiric Strike',
    icon: 'inv_ability_sanlayndeathknight_vampiricstrike',
    runesCost: 1,
    runicPowerCost: -10, // Blood DK has 15 RP due to Heart Strike modifiers. Unholy does not. we don't currently use this except to detect generators, so it being slightly wrong for blood is okay
  },
  VAMPIRIC_STRIKE_TRIGGER_BUFF: {
    id: 433899,
    name: 'Vampiric Strike',
    icon: 'inv_ability_sanlayndeathknight_vampiricstrike.jpg',
  },
  GIFT_OF_THE_SANLAYN_BUFF: {
    id: 434153,
    name: "Gift of the San'layn",
    icon: 'spell_deathknight_bloodtap.jpg',
  },
  INFLICTION_OF_SORROW: {
    id: 434144,
    name: 'Infliction of Sorrow',
    icon: 'ability_warrior_bloodbath.jpg',
  },
  ESSENCE_OF_THE_BLOOD_QUEEN_BUFF: {
    id: 433925,
    name: 'Essence of the Blood Queen',
    icon: 'inv_misc_herb_talandrasrose',
  },
} satisfies Record<string, Spell>;

const runeforges = {
  RUNE_OF_THE_FALLEN_CRUSADER: {
    id: 53344,
    name: 'Rune of the Fallen Crusader',
    icon: 'spell_holy_retributionaura',
    effectId: 3368,
  },

  RUNE_OF_RAZORICE: {
    id: 53343,
    name: ' Rune of Razorice',
    icon: 'spell_frost_frostarmor',
    effectId: 3370,
  },

  RUNE_OF_THE_STONESKIN_GARGOYLE: {
    id: 62158,
    name: 'Rune of the Stoneskin Gargoyle',
    icon: 'inv_sword_130',
    effectId: 3847,
  },

  RUNE_OF_HYSTERIA: {
    id: 326911,
    name: 'Rune of Hysteria',
    icon: 'ability_deathknight_runicimpowerment',
    effectId: 6243,
  },

  RUNE_OF_SANGUINATION: {
    id: 326805,
    name: 'Rune of Sanguination',
    icon: 'ability_argus_deathfog',
    effectId: 6241,
  },

  RUNE_OF_APOCALYPSE: {
    id: 327082,
    name: 'Rune of Apocalypse',
    icon: 'spell_deathknight_thrash_ghoul',
    effectId: 6245,
  },

  RUNE_OF_UNENDING_THIRST: {
    id: 326977,
    name: 'Rune of Unending Thirst',
    icon: 'spell_nzinsanity_bloodthirst',
    effectId: 6244,
  },

  RUNE_OF_SPELLWARDING: {
    id: 326855,
    name: 'Rune of Spellwarding',
    icon: 'spell_fire_twilightfireward',
    effectId: 6242,
  },
} satisfies Record<string, Enchant>;

const joined = {
  ...spells,
  ...runeforges,
} as const;

export default joined;
